export class After {
  values() {
    return 1;
  }
}

export class Before {
  values() {
    return -1;
  }
}
